module.exports = __webpack_public_path__ + "img/reschedicon.eb9aedec.svg";